import type { ReactNode } from "react"

import { StandardChip } from "../../../../../shared/components/badges/StandardChip"
import { SearchableText } from "../../../../../shared/components/search/Searchable"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"

import { MeetingRoomBookingState } from "../meetingRoomsTypes"
import type { MeetingRoomBookingItem } from "../meetingRoomsTypes"
import { MeetingRoomBookingMeta } from "./MeetingRoomBookingMeta"
import { MeetingRoomBookingStateChip } from "./MeetingRoomBookingStateChip"
import { MeetingRoomBookingTags } from "./MeetingRoomBookingTags"
import { MeetingRoomsListRow } from "./MeetingRoomsListRow"

type Props = Readonly<{
    item: MeetingRoomBookingItem
    lead: ReactNode
    trailing: ReactNode
    searchRegex?: RegExp
    onOpen: (item: MeetingRoomBookingItem) => void
}>

export function MeetingRoomBookingRow({ item, lead, trailing, searchRegex, onOpen }: Props) {
    const { booking, room, state } = item

    return (
        <MeetingRoomsListRow
            lead={lead}
            title={<SearchableText search={searchRegex}>{booking.meetingName}</SearchableText>}
            chip={<MeetingRoomBookingStateChip state={state} />}
            meta={<MeetingRoomBookingMeta booking={booking} room={room} searchRegex={searchRegex} />}
            metaTags={<MeetingRoomBookingTags booking={booking} room={room} />}
            trailing={trailing}
            tag={
                booking.participants !== undefined && (
                    <StandardChip placement="table" size="small" variant="grey">
                        <LocalizedStrict
                            id="service-center-meeting-rooms-booking-participants"
                            vars={{ participants: booking.participants }}
                        >
                            <span>{booking.participants} people</span>
                        </LocalizedStrict>
                    </StandardChip>
                )
            }
            isHighlighted={state === MeetingRoomBookingState.IN_PROGRESS}
            onClick={() => onOpen(item)}
        />
    )
}
